import React from "react";
import { View, StyleSheet } from "react-native";
import { theme } from "../theme/theme";
import OutbackWatermark from "./OutbackWatermark";

/**
 * Fixed app backdrop: page colour + Uluru watermark.
 * Sits at zIndex 0; all screen content renders in a transparent layer above.
 */
const AppBackground = () => (
  <View style={styles.layer} pointerEvents="none">
    <View style={styles.baseFill} />
    <OutbackWatermark />
  </View>
);

const styles = StyleSheet.create({
  layer: {
    ...StyleSheet.absoluteFillObject,
    zIndex: 0,
  },
  baseFill: {
    ...StyleSheet.absoluteFillObject,
    backgroundColor: theme.colors.background,
  },
});

export default AppBackground;
